import { sprintf } from 'sprintf-js';
import { apiInstance } from 'api/utils';
import { SearchParamsType } from 'api/types';

const URLS = {
  GET_GROUPS: '/org/%s/groups/',
  GET_GROUP: '/org/%s/groups/%s/',
  UPDATE_GROUP: '/org/%s/groups/%s/',
  DELETE_GROUP: '/org/%s/groups/%s/',
  CREATE_GROUP: '/org/%s/groups/',
};

export const organizationGroups = {
  getGroups: ({
    organizationCodename,
    params,
  }: {
    organizationCodename: string;
    params?: SearchParamsType;
  }) =>
    apiInstance.request({
      method: 'GET',
      url: sprintf(URLS.GET_GROUPS, organizationCodename),
      params: {
        ...params,
      },
    }),
  getGroup: ({
    organizationCodename,
    groupId,
  }: {
    organizationCodename: string;
    groupId: string;
  }) =>
    apiInstance.request({
      method: 'GET',
      url: sprintf(URLS.GET_GROUP, organizationCodename, groupId),
    }),
  createGroup: ({
    organizationCodename,
    groupData,
  }: {
    organizationCodename: string;
    groupData: {
      name: string;
      users?: number[] | null;
    };
  }) =>
    apiInstance.request({
      method: 'POST',
      url: sprintf(URLS.CREATE_GROUP, organizationCodename),
      data: groupData,
    }),
  deleteGroup: ({
    organizationCodename,
    groupId,
  }: {
    organizationCodename: string;
    groupId: number;
  }) =>
    apiInstance.request({
      method: 'DELETE',
      url: sprintf(URLS.DELETE_GROUP, organizationCodename, groupId),
    }),
  updateGroup: ({
    organizationCodename,
    groupId,
    data,
  }: {
    organizationCodename: string;
    groupId: number;
    data: {
      name?: string;
      users?: number[] | null;
      shared_projects?: number[];
      shared_products?: number[];
    };
  }) =>
    apiInstance.request({
      method: 'PATCH',
      url: sprintf(URLS.GET_GROUP, organizationCodename, groupId),
      data,
    }),
};
